module.exports = __webpack_public_path__ + "img/MySQL.80a7d858.png";